import type {
  FacilityLogin,
  FacilityLoginResponse,
  FacilityResponce,
  ForgotPassword,
  ResetPassword,
  ChangePassword,
  EmailExpireResponce,
} from '../../API/services/loginServices';
import {
  forgotPasswordEmail,
  getLogin,
  resetPassword,
  changePassword,
  checkEmailExpire,
} from '../../API/services/loginServices';
import { useMutation, useQuery } from '@tanstack/react-query';

export const useFacilityLogin = () => {
  return useMutation<FacilityLoginResponse, Error, FacilityLogin>({
    mutationFn: async ({ ...payload }) => {
      const data = await getLogin(payload);
      return data;
    },
  });
};

export const useFacilityForgotPasswordEmail = () => {
  return useMutation<FacilityResponce, Error, ForgotPassword>({
    mutationFn: async ({ ...payload }) => {
      const data = await forgotPasswordEmail(payload);
      return data;
    },
  });
};

export const useFacilityResetPassword = () => {
  return useMutation<FacilityResponce, Error, ResetPassword>({
    mutationFn: async ({ ...payload }) => {
      const data = await resetPassword(payload);
      return data;
    },
  });
};

export const useFacilityChangePassword = () => {
  return useMutation<FacilityResponce, Error, ChangePassword>({
    mutationFn: async ({ ...payload }) => {
      const data = await changePassword(payload);
      return data;
    },
  });
};

export const useCheckEmailExpire = (token: string) => {
  const { data, isLoading, isError, error, refetch } =
    useQuery<EmailExpireResponce>({
      queryKey: ['checkEmailExpire', token],
      queryFn: async () => {
        const data = await checkEmailExpire(token);
        return data;
      },
      staleTime: 0,
      gcTime: 0,
      enabled: !!token,
    });

  return {
    emailExpireData: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
